export default function handleFlyoutMenu(navWrapperClass, navItemWithFlyoutClass, flyoutClass, linkGroupClass, clonedLinkText) {
  const navWrapper = document.querySelector('.' + navWrapperClass);
  if (!navWrapper) return;

  navWrapper.querySelectorAll('.' + navItemWithFlyoutClass).forEach(item => {
    const flyout = item.querySelector('.' + flyoutClass);
    if (!flyout) return;

    const originalFlyoutClass = flyout.className;
    const link = item.querySelector(':scope > a');
    if (!link) return;

    const linkText = link.textContent.trim();

    flyout.className = linkGroupClass;

    const wrapper = document.createElement('div');
    wrapper.className = originalFlyoutClass;
    flyout.parentNode.insertBefore(wrapper, flyout);
    wrapper.appendChild(flyout);

    const clone = link.cloneNode(true);
    clone.textContent = linkText + ' ' + clonedLinkText;
    clone.classList.add('cloned-link');
    wrapper.parentNode.insertBefore(clone, wrapper);

    const span = document.createElement('span');
    span.textContent = linkText;
    link.replaceWith(span);
  });

  navWrapper.classList.add('is-manipulated');
}
